var map = {
	"./video1-acacia.mp4": 1017,
	"./video1-beenleigh.mp4": 1018,
	"./video1-brisbane.mp4": 1019,
	"./video1-coopers.mp4": 1020,
	"./video1-goldcoast.mp4": 1021,
	"./video1-home.mp4": 1022,
	"./video1-ipswich.mp4": 1023,
	"./video1-rocklea.mp4": 1024,
	"./video1-sunnybank.mp4": 1025,
	"./video1-toowoomba.mp4": 1026,
	"./video1-underwood.mp4": 1027,
	"./video1-woodridge.mp4": 1028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1016;